import React from "react";
import { useAuthUser } from "react-auth-kit";
import { MentionsInput } from "react-mentions";
import { Mention } from "react-mentions";
import { useSelector } from "react-redux";
import { getSubDomainAccessStatus } from "../../RolePermissionAccess/RolePermissionAccess";

function LeadCallDispositionComment(props: any) {
  const { setComment, comment } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );

  const handleCommentChange = React.useCallback(
    (event: any) => {
      setComment(event.target.value);
    },
    [comment]
  );

  return (
    <div>
      <div>
        <textarea
          value={comment}
          onChange={(e) => {
            if (e.target.value.length <= 200) {
              handleCommentChange(e);
            }
          }}
          rows={4}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
            outline: "none",
          }}
          onFocus={(e) => {
            e.target.style.border = "1px solid #ccc"; // 🔥 prevents blue border on focus
          }}
          onBlur={(e) => {
            e.target.style.border = "1px solid #ccc"; // keeps same border after focus
          }}
        />
        <div style={{ fontSize: "12px", textAlign: "right", color: "#555" }}>
          {comment.length}/200
        </div>
      </div>
    </div>
  );
}

export default LeadCallDispositionComment;
